import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered modal-md",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header bg-accent text-white border-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Buka Laci", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-12 px-2" }
const _hoisted_10 = { class: "form" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col px-1",
  for: ""
}, "Kenapa mau buka Laci?", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = {
  key: 0,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass($setup.modalClass),
      style: _normalizeStyle($setup.modalStyle)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.hideModal && $setup.hideModal(...args))),
              type: "button",
              class: "close text-white",
              "data-dismiss": "modal",
              "aria-label": "Close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("form", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.reason) = $event)),
                      class: "form-control option",
                      autocomplete: "off",
                      placeholder: "Alasan"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listReason, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 'reason' + index,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_13))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, $setup.reason]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-dismiss": "modal",
              tabindex: "5",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.hideModal && $setup.hideModal(...args)))
            }, " Batal "),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-accent",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitForm && $setup.submitForm(...args)), ["prevent"]))
            }, "Buka")
          ])
        ])
      ])
    ], 6),
    ($setup.modalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}